var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinieGestricheltMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 729",
    style: {
      enableBackground: "new 0 0 269.3 729"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#868686;}\n\t.st1{fill:#ECECEC;}\n\t.st2{fill:#A3A3A3;}\n\t.st3{fill:#C4C4C4;}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#C1C1C1;}\n\t.st6{fill:#DDDDDD;}\n\t.st7{fill:#EDEDED;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.7,384.5l-0.9-1.1c-2,2.4-4,4.8-5.8,7.2l0.9,1C51.7,389.4,53.7,386.9,55.7,384.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,406.6l-1-0.9c-1.8,2.6-3.5,5.3-5.1,8l1,0.9C35.6,411.9,37.2,409.4,39,406.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,395.4l-0.9-1c-1.9,2.5-3.8,5.1-5.5,7.6l1,1C43.3,400.4,45.2,397.9,47.1,395.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.9,355l-0.8-1.2c-2.2,2.1-4.4,4.2-6.5,6.2l0.8,1.2C79.5,359.2,81.7,357.1,83.9,355z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,418.6l-1-0.8c-1.6,2.8-3.1,5.7-4.5,8.5l1.1,0.8C28.5,424.2,30,421.4,31.6,418.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.7,374.2l-0.8-1.1c-2.1,2.3-4.2,4.6-6.1,6.8l0.8,1.1C60.7,378.9,62.7,376.5,64.7,374.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.2,364.4l-0.8-1.2c-2.2,2.2-4.3,4.4-6.3,6.5l0.8,1.1C69.9,368.9,72,366.6,74.2,364.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,517.8c1,3.1,2.1,6.2,3.2,9.2l1.2-0.6c-1.2-3-2.3-6.1-3.2-9.1L16.9,517.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,431.4l-1.1-0.7c-1.3,3-2.7,6-3.8,9l1.2,0.6C22.4,437.2,23.7,434.4,25.1,431.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,503.2c0.6,3.2,1.3,6.5,2.2,9.7l1.2-0.5c-0.8-3.2-1.6-6.4-2.2-9.5L13.4,503.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,444.2c-1.1,3.1-2.1,6.3-2.9,9.4l1.2,0.5c0.8-3.1,1.8-6.2,2.8-9.3L18.5,444.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,531.5c1.2,2.9,2.7,5.8,4.2,8.7l1.1-0.8c-1.5-2.9-2.9-5.7-4.2-8.6L22.1,531.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.8,346l-0.8-1.2c-2.2,2-4.5,4-6.7,6l0.8,1.2C89.3,350,91.6,348,93.8,346z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,488.2l-1.2,0.1c0.2,3.3,0.4,6.7,0.9,10l1.2-0.2C13.4,494.9,13.1,491.5,13,488.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,458.9l-1.2-0.4c-0.7,3.3-1.3,6.6-1.8,9.8l1.2,0.2C14.3,465.4,14.9,462,15.7,458.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,473.4l-1.2-0.2c-0.3,3.3-0.5,6.7-0.5,10h1.2C12.9,480,13.1,476.8,13.3,473.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.2,95.2c-1.7-2.6-3.4-5.3-5.2-7.9l-1,0.9c1.7,2.6,3.5,5.2,5.1,7.9L223.2,95.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.9,290.4l-0.6-1.3c-2.5,1.6-4.9,3.2-7.3,4.8l0.6,1.3C163,293.8,165.4,292.1,167.9,290.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6,544.4c1.5,2.7,3.2,5.4,4.9,8.2l1-0.9c-1.7-2.7-3.3-5.4-4.8-8.1L28.6,544.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.8,133.5c-1.2-3-2.5-6-3.8-8.9l-1.1,0.7c1.3,3,2.6,5.9,3.8,8.9L242.8,133.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.8,33.2c-2.3-1.9-4.7-3.7-7.1-5.4l-0.7,1.3c2.3,1.7,4.7,3.5,7,5.4L168.8,33.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.1,72.2c-1.9-2.4-3.8-4.8-5.8-7.2l-0.9,1.1c2,2.3,3.9,4.7,5.8,7.1L207.1,72.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.7,147.4c-1-3.1-2.1-6.2-3.2-9.3l-1.2,0.6c1.2,3.1,2.3,6.2,3.2,9.2L247.7,147.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.6,191.4h1.2c-0.1-3.3-0.3-6.6-0.7-10l-1.2,0.2C254.2,184.9,254.5,188.2,254.6,191.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.3,176.6l1.2-0.2c-0.4-3.2-1-6.5-1.7-9.8l-1.2,0.4C252.3,170.1,252.8,173.4,253.3,176.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.2,305.2l-0.7-1.3c-2.4,1.7-4.8,3.4-7.2,5.1l0.7,1.3C141.3,308.6,143.7,306.9,146.2,305.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,316.9l0.7,1.3c2.3-1.7,4.7-3.5,7.1-5.2l-0.7-1.3C132.3,313.4,130,315.1,127.7,316.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.8,320.8l-0.7-1.3c-2.3,1.8-4.8,3.6-7,5.4l0.7,1.3C120.1,324.4,122.4,322.5,124.8,320.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.3,328.9l-0.7-1.3c-2.3,1.9-4.7,3.7-6.9,5.6l0.7,1.2C109.7,332.6,112,330.8,114.3,328.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.7,11.9c-2.6-1.3-5.2-2.5-7.8-3.6l-0.4,1.4c2.6,1.1,5.2,2.3,7.8,3.6L135.7,11.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157,297.8l-0.6-1.3c-2.4,1.7-4.8,3.3-7.2,5l0.7,1.3C152.1,301,154.5,299.4,157,297.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.2,25.4c-2.4-1.7-4.9-3.3-7.3-4.8l-0.6,1.3c2.4,1.5,4.9,3.1,7.2,4.8L158.2,25.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,337.4l-0.8-1.2c-2.3,1.9-4.6,3.9-6.8,5.8l0.8,1.2C99.4,341.1,101.7,339.2,104,337.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.1,18.2c-2.5-1.5-5.1-2.9-7.6-4.3l-0.5,1.4c2.5,1.3,5,2.8,7.5,4.2L147.1,18.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M161.1,672.7c-2-2-4.1-4-6.6-6.2l-0.8,1.2c2.4,2.2,4.6,4.2,6.5,6.2L161.1,672.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.2,61.4c-2-2.3-4.1-4.6-6.2-6.8l-0.8,1.1c2.1,2.2,4.2,4.4,6.2,6.7L198.2,61.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.2,266l0.6,1.3c2.5-1.5,4.9-2.9,7.5-4.4l-0.6-1.3C209.2,263.1,206.7,264.6,204.2,266z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.1,272.9l0.6,1.3c2.4-1.5,4.9-3,7.4-4.5l-0.6-1.3C198,269.9,195.6,271.4,193.1,272.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209,76.8c1.8,2.5,3.7,5,5.5,7.5l0.9-1c-1.8-2.5-3.7-5.1-5.5-7.5L209,76.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,279.8l0.6,1.3c2.4-1.5,4.9-3.1,7.4-4.6l-0.6-1.3C186.9,276.6,184.4,278.2,182,279.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.5,36.2c-0.2,0.4-0.5,0.8-0.8,1.2c2.2,1.8,4.4,3.8,6.6,5.7l0.8-1.2C176.9,40.1,174.7,38.2,172.5,36.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,51.3c-2.2-2.2-4.3-4.3-6.5-6.3l-0.8,1.2c2.2,2,4.3,4.2,6.4,6.3L188.8,51.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.6,37.3c0.1,0,0.1,0.1,0.2,0.1c0.2-0.4,0.5-0.8,0.7-1.2c-0.1-0.1-0.2-0.1-0.2-0.2L171.6,37.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.5,259.4l0.6,1.3c2.5-1.4,5-2.9,7.5-4.3l-0.5-1.4C220.5,256.6,218,258,215.5,259.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.4,107.5c-1.5-2.8-3.1-5.5-4.8-8.3l-1,0.9c1.6,2.7,3.2,5.5,4.8,8.2L230.4,107.5z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.2,233.8l1,0.9c1.6-2.7,3-5.7,4.2-8.8l-1-0.7C248.2,228.1,246.7,231,245.2,233.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.9,220.6l1.2,0.5c1-3.1,1.8-6.3,2.3-9.7l-1.2-0.3C252.6,214.4,251.8,217.6,250.9,220.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.6,196.4c-0.1,3.4-0.3,6.7-0.7,9.9l1.2,0.2c0.4-3.2,0.6-6.6,0.7-10L254.6,196.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.2,152.1l-1.2,0.5c0.9,3.2,1.8,6.4,2.5,9.5l1.2-0.4C251,158.5,250.2,155.3,249.2,152.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.7,252.9l0.6,1.3c2.5-1.6,4.9-3.4,7.2-5.3l-0.8-1.2C231.6,249.6,229.2,251.3,226.7,252.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.7,111.7l-1.1,0.8c1.5,2.8,2.9,5.7,4.2,8.6l1.1-0.7C235.6,117.3,234.2,114.5,232.7,111.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.9,244.6l0.8,1.1c2.2-2.2,4.2-4.6,5.9-7.2l-1-1C241,240.1,239.1,242.5,236.9,244.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.9,286.8l0.6,1.3c2.4-1.6,4.8-3.1,7.3-4.7l-0.6-1.3C175.8,283.6,173.4,285.2,170.9,286.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.9,616.5c2.2,2,4.6,3.9,6.8,5.8l0.8-1.2c-2.2-1.9-4.5-3.8-6.8-5.8L91.9,616.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.8,607.6c2.2,1.9,4.4,4,6.7,6l0.8-1.2c-2.3-2-4.6-4-6.7-6L81.8,607.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,598.2c2.1,2,4.3,4.1,6.6,6.2l0.8-1.2c-2.2-2.1-4.4-4.2-6.6-6.2L71.9,598.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.2,625.2c2.3,1.9,4.6,3.8,6.9,5.7l0.7-1.2c-2.2-1.9-4.6-3.7-6.9-5.7L102.2,625.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.5,633.7c2.3,1.9,4.7,3.8,6.9,5.6l0.7-1.2c-2.2-1.8-4.6-3.7-6.9-5.6L112.5,633.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,588.7c2.1,2.1,4.2,4.3,6.3,6.5l0.8-1.2c-2.2-2.2-4.3-4.3-6.3-6.4L62.3,588.7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2,567.9c1.8,2.4,3.8,4.8,5.8,7.2l1-1.1c-2-2.4-4-4.8-5.8-7.2L44.2,567.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.1,578.6c1.9,2.2,4,4.5,6.2,6.8l0.8-1.1c-2.1-2.3-4.2-4.6-6.1-6.8L53.1,578.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.8,699.2l0.5,0.5c1.2-1.4,1.9-2.8,2.1-4.3l-0.6-0.2C173.6,696.6,172.9,697.9,171.8,699.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.6,640.8l-0.7,1.2l1.5,1.2c1.8,1.5,3.7,2.9,5.4,4.4l0.7-1.2c-1.8-1.4-3.6-2.9-5.4-4.4L123.6,640.8z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.2,683.1c-1.7-2.3-3.6-4.6-5.9-7.1l-0.8,1.1c2.3,2.5,4.2,4.8,5.8,7L170.2,683.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.7,687.5c1.2,2.1,1.8,3.9,1.9,5.7l0.8-0.1c-0.1-1.9-0.8-3.9-2.1-6.3L171.7,687.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,556.5c1.7,2.5,3.5,5.1,5.4,7.7l0.9-1c-1.9-2.5-3.7-5.1-5.4-7.6L36,556.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.8,701.8l0.2,0.6c1.1-0.5,2.1-1.1,3-1.6l-0.2-0.6C169.8,700.7,168.9,701.3,167.8,701.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.3,650.4c2.3,1.9,4.7,3.8,6.9,5.6l0.7-1.2c-2.2-1.8-4.6-3.7-6.9-5.6L133.3,650.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.7,658.8c2.5,2.1,4.8,4,6.8,5.8l0.7-1.2c-2.1-1.8-4.2-3.7-6.8-5.8L143.7,658.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinieGestricheltMobile);
export default __webpack_public_path__ + "static/media/Linie_gestrichelt_mobile.12b34c74444e078928bb040c8e076712.svg";
export { ForwardRef as ReactComponent };